// extracted by mini-css-extract-plugin
export default {"container":"error_container__1hVQM","actions":"error_actions__1jCE6","button":"error_button__12-lP","igaNoelTheme":"error_igaNoelTheme__2nfcQ","nflTheme":"error_nflTheme__jqrSD"};